// extracted by mini-css-extract-plugin
module.exports = {"row_margin_top":"style_row_margin_top__1i7fV","footer_box":"style_footer_box__1qSNv"};